var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivationDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198",
    transform: "translate(-364 -626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "date-outline-alerted",
    transform: "translate(356.341 626.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M24.71,36.149h-.745v6.476H11.546V32.867h1.331V31.98H11.435a.79.79,0,0,0-.776.8v9.926a.79.79,0,0,0,.776.8H24.076a.79.79,0,0,0,.776-.8V36.14Z",
    transform: "translate(0 -26.846)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M42.64,74.62h.887v.887H42.64Z",
    transform: "translate(-29.32 -65.938)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M74.62,74.62h.887v.887H74.62Z",
    transform: "translate(-58.639 -65.938)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M42.64,101.27h.887v.887H42.64Z",
    transform: "translate(-29.32 -90.37)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M74.62,101.27h.887v.887H74.62Z",
    transform: "translate(-58.639 -90.37)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M106.6,101.27h.887v.887H106.6Z",
    transform: "translate(-87.958 -90.37)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M138.58,101.27h.887v.887h-.887Z",
    transform: "translate(-117.276 -90.37)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M42.64,127.92h.887v.887H42.64Z",
    transform: "translate(-29.32 -114.802)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M74.62,127.92h.887v.887H74.62Z",
    transform: "translate(-58.639 -114.802)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M106.6,127.92h.887v.887H106.6Z",
    transform: "translate(-87.958 -114.802)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M138.58,127.92h.887v.887h-.887Z",
    transform: "translate(-117.276 -114.802)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M48.414,14.208a.444.444,0,0,0,.444-.444V11.1a.444.444,0,0,0-.887,0v2.661A.444.444,0,0,0,48.414,14.208Z",
    transform: "translate(-34.206 -7.3)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M114.074,2.978l-2.537,4.373a.568.568,0,0,0,.488.887H117.1a.568.568,0,0,0,.488-.887l-2.537-4.373a.568.568,0,0,0-.98,0Z",
    transform: "translate(-92.394)",
    fill: "#888"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    width: 20,
    height: 20,
    transform: "translate(364 626)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivationDate);
export default __webpack_public_path__ + "static/media/activation-date.0d6969685c84871cb3a4030d1af8eaed.svg";
export { ForwardRef as ReactComponent };